/**
 * Provenance chip for audits created in the Figma plugin (origin ===
 * "plugin"). It records HOW the audit was started — not a quality
 * signal — so the pill stays neutral; the real (multi-colour) Figma
 * mark makes the source instantly recognisable.
 *
 * Shared between the dashboard "my audits" list and the audit canvas so
 * the cue reads identically in both places. SVG uses Figma's official
 * five-shape logo geometry (viewBox 0 0 38 57).
 */
export function FigmaOriginChip({ className }: { className?: string }) {
  return (
    <span
      className={`figma-origin-chip${className ? ` ${className}` : ""}`}
      title="This audit was run in the Figma plugin"
    >
      <svg
        className="figma-origin-chip-glyph"
        viewBox="0 0 38 57"
        aria-hidden="true"
      >
        <path
          d="M19 28.5C19 23.2533 23.2533 19 28.5 19C33.7467 19 38 23.2533 38 28.5C38 33.7467 33.7467 38 28.5 38C23.2533 38 19 33.7467 19 28.5Z"
          fill="#1ABCFE"
        />
        <path
          d="M0 47.5C0 42.2533 4.25329 38 9.5 38H19V47.5C19 52.7467 14.7467 57 9.5 57C4.25329 57 0 52.7467 0 47.5Z"
          fill="#0ACF83"
        />
        <path
          d="M19 0V19H28.5C33.7467 19 38 14.7467 38 9.5C38 4.25329 33.7467 0 28.5 0H19Z"
          fill="#FF7262"
        />
        <path
          d="M0 9.5C0 14.7467 4.25329 19 9.5 19H19V0H9.5C4.25329 0 0 4.25329 0 9.5Z"
          fill="#F24E1E"
        />
        <path
          d="M0 28.5C0 33.7467 4.25329 38 9.5 38H19V19H9.5C4.25329 19 0 23.2533 0 28.5Z"
          fill="#A259FF"
        />
      </svg>
      Run in Figma
    </span>
  );
}
